var _defs, _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElementFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fireBg",
    x1: 10,
    y1: 8,
    x2: 86,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFD6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38A4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fireOuter",
    x1: 48,
    y1: 20,
    x2: 48,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF2C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC15B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fireInner",
    x1: 48,
    y1: 34,
    x2: 48,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE39E"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 22,
    fill: "url(#fireBg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 20C52 31 69 40 69 57C69 67 60.1 76 48 76C35.9 76 27 67 27 57C27 43 37.1 34 48 20Z",
    fill: "url(#fireOuter)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 34C52 43 61 48 61 58C61 64.6 55.7 70 49 70C42.3 70 37 64.6 37 58C37 49.5 43.8 43 49 34Z",
    fill: "url(#fireInner)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementFire);
export default __webpack_public_path__ + "static/media/element-fire.2bacef9020c02951d7095ddf6fb9ee7c.svg";
export { ForwardRef as ReactComponent };